import {PaymentEdit} from "components/front/BILLING/Payment/Edit/PaymentEdit"
import React from "react"

export const PaymentAddRoute = () => {
  return <div className="payment-add-route">
    <h1>Paiement</h1>
    <PaymentEdit />
  </div>
}